// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/font/Inter-VariableFont.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Inter";
  src: local("Inter"), url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
}
.spinner {
  display: inline-block;
  position: absolute;
  height: 100vh;
  width: 100vw;
  z-index: 9999999;
  width: 80px;
  height: 80px;
}

.spinner div {
  position: absolute;
  width: 6px;
  height: 6px;
  background: #EE3A24;
  border-radius: 50%;
  animation: spinner 1.2s linear infinite;
}

.spinner div:nth-child(1) {
  animation-delay: 0s;
  top: 37px;
  left: 66px;
}

.spinner div:nth-child(2) {
  animation-delay: -0.1s;
  top: 22px;
  left: 62px;
}

.spinner div:nth-child(3) {
  animation-delay: -0.2s;
  top: 11px;
  left: 52px;
}

.spinner div:nth-child(4) {
  animation-delay: -0.3s;
  top: 7px;
  left: 37px;
}

.spinner div:nth-child(5) {
  animation-delay: -0.4s;
  top: 11px;
  left: 22px;
}

.spinner div:nth-child(6) {
  animation-delay: -0.5s;
  top: 22px;
  left: 11px;
}

.spinner div:nth-child(7) {
  animation-delay: -0.6s;
  top: 37px;
  left: 7px;
}

.spinner div:nth-child(8) {
  animation-delay: -0.7s;
  top: 52px;
  left: 11px;
}

.spinner div:nth-child(9) {
  animation-delay: -0.8s;
  top: 62px;
  left: 22px;
}

.spinner div:nth-child(10) {
  animation-delay: -0.9s;
  top: 66px;
  left: 37px;
}

.spinner div:nth-child(11) {
  animation-delay: -1s;
  top: 62px;
  left: 52px;
}

.spinner div:nth-child(12) {
  animation-delay: -1.1s;
  top: 52px;
  left: 62px;
}

@keyframes spinner {
  0%, 20%, 80%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.5);
  }
}`, "",{"version":3,"sources":["webpack://./src/style/_fonts.scss","webpack://./src/style/components/Spinner.scss","webpack://./src/style/_colors.scss"],"names":[],"mappings":"AAAA;EACI,oBAAA;EACA,+EAAA;ACCJ;AADA;EACI,qBAAA;EACA,kBAAA;EACA,aAAA;EACA,YAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;AAGJ;;AADE;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,mBCfY;EDgBZ,kBAAA;EACA,uCAAA;AAIJ;;AAFE;EACE,mBAAA;EACA,SAAA;EACA,UAAA;AAKJ;;AAHE;EACE,sBAAA;EACA,SAAA;EACA,UAAA;AAMJ;;AAJE;EACE,sBAAA;EACA,SAAA;EACA,UAAA;AAOJ;;AALE;EACE,sBAAA;EACA,QAAA;EACA,UAAA;AAQJ;;AANE;EACE,sBAAA;EACA,SAAA;EACA,UAAA;AASJ;;AAPE;EACE,sBAAA;EACA,SAAA;EACA,UAAA;AAUJ;;AARE;EACE,sBAAA;EACA,SAAA;EACA,SAAA;AAWJ;;AATE;EACE,sBAAA;EACA,SAAA;EACA,UAAA;AAYJ;;AAVE;EACE,sBAAA;EACA,SAAA;EACA,UAAA;AAaJ;;AAXE;EACE,sBAAA;EACA,SAAA;EACA,UAAA;AAcJ;;AAZE;EACE,oBAAA;EACA,SAAA;EACA,UAAA;AAeJ;;AAbE;EACE,sBAAA;EACA,SAAA;EACA,UAAA;AAgBJ;;AAdE;EACE;IACE,mBAAA;EAiBJ;EAfE;IACE,qBAAA;EAiBJ;AACF","sourcesContent":["@font-face {\n    font-family: \"Inter\";\n    src: local(\"Inter\"),\n     url(\"../assets/font/Inter-VariableFont.ttf\") format(\"truetype\");\n   }\n@mixin primeFont() {\n    font-family: \"Inter\";\n}","@import '../mixins';\n\n.spinner {\n    display: inline-block;\n    position: absolute;\n    height: 100vh;\n    width: 100vw;\n    z-index: 9999999;\n    width: 80px;\n    height: 80px;\n  }\n  .spinner div {\n    position: absolute;\n    width: 6px;\n    height: 6px;\n    background: $primary-color;\n    border-radius: 50%;\n    animation: spinner 1.2s linear infinite;\n  }\n  .spinner div:nth-child(1) {\n    animation-delay: 0s;\n    top: 37px;\n    left: 66px;\n  }\n  .spinner div:nth-child(2) {\n    animation-delay: -0.1s;\n    top: 22px;\n    left: 62px;\n  }\n  .spinner div:nth-child(3) {\n    animation-delay: -0.2s;\n    top: 11px;\n    left: 52px;\n  }\n  .spinner div:nth-child(4) {\n    animation-delay: -0.3s;\n    top: 7px;\n    left: 37px;\n  }\n  .spinner div:nth-child(5) {\n    animation-delay: -0.4s;\n    top: 11px;\n    left: 22px;\n  }\n  .spinner div:nth-child(6) {\n    animation-delay: -0.5s;\n    top: 22px;\n    left: 11px;\n  }\n  .spinner div:nth-child(7) {\n    animation-delay: -0.6s;\n    top: 37px;\n    left: 7px;\n  }\n  .spinner div:nth-child(8) {\n    animation-delay: -0.7s;\n    top: 52px;\n    left: 11px;\n  }\n  .spinner div:nth-child(9) {\n    animation-delay: -0.8s;\n    top: 62px;\n    left: 22px;\n  }\n  .spinner div:nth-child(10) {\n    animation-delay: -0.9s;\n    top: 66px;\n    left: 37px;\n  }\n  .spinner div:nth-child(11) {\n    animation-delay: -1s;\n    top: 62px;\n    left: 52px;\n  }\n  .spinner div:nth-child(12) {\n    animation-delay: -1.1s;\n    top: 52px;\n    left: 62px;\n  }\n  @keyframes spinner {\n    0%, 20%, 80%, 100% {\n      transform: scale(1);\n    }\n    50% {\n      transform: scale(1.5);\n    }\n  }","$primary-color: #EE3A24;\n$secondary-color: #923D32;\n\n$text_black : #000000;\n$color_white : #fff;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
